var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGmailLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 24,
    viewBox: "0 0 33 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10629_6395",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9999 0H0V24H31.9999V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10629_6395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.18182 24.0008H7.27272V11.6371L0 6.18262V21.819C0 23.0263 0.978182 24.0008 2.18182 24.0008Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7273 24.0008H29.8182C31.0256 24.0008 32 23.0226 32 21.819V6.18262L24.7273 11.6371",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7273 2.18215V11.6367L32 6.18215V3.27307C32 0.574876 28.9201 -0.963306 26.7637 0.654875",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.27271 11.6371V2.18262L16 8.72806L24.7272 2.18262V11.6371L16 18.1826",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 3.27307V6.18215L7.27272 11.6367V2.18215L5.23637 0.654875C3.07637 -0.963306 0 0.574876 0 3.27307Z",
    fill: "#C5221F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailLogo);
export default __webpack_public_path__ + "static/media/Gmail_Logo.488ce567.svg";
export { ForwardRef as ReactComponent };